import { lazy } from 'react';
import KeepAlive from 'react-activation';
import Loading from '../components/Loading';
import { Suspense } from "react";

const App = lazy(() => import('@/layouts/App'));
const FastEntrance = lazy(() => import('@/pages/fast-entrance/FastEntrance'));
const fastEntranceRoutes = [
    {
        path: "/layout",
        name: 'App',
        element: <App />,
        children: [
            {
                path: 'fastEntrance',
                name: '快捷入口',
                element: <KeepAlive name='/layout/fastEntrance'>
                    <Suspense fallback={<Loading />}>
                        <FastEntrance/>
                    </Suspense>
                </KeepAlive>
            }
        ]
    },
]
export default fastEntranceRoutes